// ProfilePage.tsx — own profile, route /profile.
// Auth-gated: redirects to /signin if no active session.

import { Navigate } from 'react-router-dom';
import { useSession } from '@/hooks';
import { ProfileView } from './ProfileView';

export function ProfilePage() {
  const { currentUser, isAuthenticated } = useSession();

  if (!isAuthenticated || !currentUser) {
    return <Navigate to={`/signin?next=${encodeURIComponent('/profile')}`} replace />;
  }

  return <ProfileView user={currentUser} isOwn />;
}
